import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

export interface TradingRule {
  id: string;
  eligible_sets: string[];
  eligible_rarities: string[];
  created_at: string;
  updated_at: string;
}

export function useTradeSettings() {
  return useQuery({
    queryKey: ['trading_settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('trading_settings')
        .select('*');

      if (error) {
        throw error;
      }

      return data as TradingRule[];
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
} 